// import React, { useState } from 'react';
// import { Line } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   LineElement,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   Tooltip,
//   Legend,
// } from 'chart.js';
// import CustomDropdown from '../../../components/CustomDropdown';

// // Register necessary Chart.js elements
// ChartJS.register(
//   LineElement,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   Tooltip,
//   Legend
// );
// const dropdownData = [
//   { value: 'Yearly', name: 'Yearly' },
//   { value: 'Monthly', name: 'Monthly' },
// ];
// const Chart = ({ chartData }) => {
//   // `period` stores the simple string value ('Yearly' or 'Monthly')
//   const [period, setPeriod] = useState(dropdownData?.[0]);

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         display: false,
//         // position: 'bottom',
//         // labels: {
//         //   usePointStyle: true, // Use circle for the legend item
//         // },
//       },
//       tooltip: { mode: 'index', intersect: false },
//     },
//     scales: {
//       y: {
//         type: 'linear',
//         // --- CUSTOM LINEAR TICKS TO MATCH THE NEW IMAGE ---
//         ticks: {
//           // Explicitly define ticks from 0 to 900 every 100, plus 1000 for '1k+'
//           values: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
//           callback: function (value) {
//             // Display '1k+' for the value 1000
//             if (value === 1000) return '1k+';
//             return value;
//           },
//         },
//         min: 0,
//         max: 1000,
//         grid: {
//           // Draw light grid lines for all ticks (as seen in the image)
//           drawOnChartArea: true,
//           color: 'rgba(0, 0, 0, 0.1)',
//         },
//       },
//       x: {
//         grid: {
//           display: false, // Hide vertical grid lines
//         },
//       },
//     },
//   };

//   return (
//     // Set fixed height (h-80 is 320px) and full width for the container
//     <div className='bg-white p-6 rounded-xl shadow-md border border-gray-100 h-96 w-full max-w-lg mx-auto'>
//       <div className='flex justify-end mb-2 w-full'>
//         <CustomDropdown
//           selectedValue={dropdownData?.[0]}
//           onSelect={(val) => setPeriod(val)}
//           width='w-24'
//           options={dropdownData}
//         />
//       </div>
//       {/* Set a div around Line to control chart height */}
//       <div style={{ height: 'calc(100% - 4rem)' }}>
//         <Line
//           // Access data using the simple string value of `period`
//           data={chartData?.[period?.value] ?? { labels: [], datasets: [] }}
//           options={options}
//         />
//       </div>
//     </div>
//   );
// };

// export default Chart;

import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from 'chart.js';

// Register necessary Chart.js elements
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const Chart = ({ chartData }) => {

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: { 
        mode: 'index', 
        intersect: false,
        callbacks: {
          label: function(context) {
            return `Value: ${context.parsed.y}`;
          }
        }
      },
    },
    scales: {
      y: {
        type: 'linear',
        ticks: {
          callback: function (value) {
            return value;
          },
        },
        grid: {
          drawOnChartArea: true,
          color: 'rgba(0, 0, 0, 0.1)',
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <div className='bg-white p-6 rounded-xl shadow-md border border-gray-100 h-96 w-full'>
      <div style={{ height: '100%' }}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default Chart;